/* Copyright 2013 - 2024 Waiterio LLC */
import Meal from '@waiterio/model/Meal.js'
import get from '@waiterio/api-client/get.js'

export default function getMeal(mealId) {
  return get({ url: 'meals/' + mealId }).then(meal => new Meal(meal))
}
